import { Injectable } from '@angular/core';

export type TourIntent = { key: string; options?: Record<string, unknown>; ts: number };

@Injectable({ providedIn: 'root' })
export class TourIntentService {
  private readonly KEY = 'tour:intent';

  setIntent(key: string, options?: Record<string, unknown>): void {
    const payload: TourIntent = { key, options, ts: Date.now() };
    try {
      localStorage.setItem(this.KEY, JSON.stringify(payload));
    } catch {}
  }

  peekIntent(): TourIntent | null {
    try {
      const raw = localStorage.getItem(this.KEY);
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  }

  consumeIntent(maxAgeMs = 10 * 60 * 1000): TourIntent | null {
    const intent = this.peekIntent();
    if (!intent) return null;
    const fresh = Date.now() - (intent.ts ?? 0) <= maxAgeMs;
    this.clearIntent();
    return fresh ? intent : null;
  }

  clearIntent(): void {
    try {
      localStorage.removeItem(this.KEY);
    } catch {}
  }
}
